<template>
    <div>
        <div class="alert alert-danger" v-if="error">
            {{ errorMessage }}
        </div>

        <form role="form">

            <div v-if="project" class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Project</label>
                <div class="col-md-8">
                    <span class="form-static-input">{{ project.name }}</span></a>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Title</label>

                <div class="col-md-8">
                    <input v-model="form.title" type="text" class="form-control" name="title"
                     :autofocus="!isEditing"
                     :class="{'is-invalid': form.errors.has('title')}" />
                    <span class="invalid-title" v-show="form.errors.has('title')">
                        @{{ form.errors.get('title') }}
                    </span>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Description</label>

                <div class="col-md-8">
                    <textarea v-model="form.description" type="text" rows="5" class="form-control" name="description"></textarea>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Additional cost</label>

                <div class="col-md-4">
                    <div class="input-group">
                          <div class="input-group-prepend">
                            <span class="input-group-text" id="basic-addon1">$</span>
                          </div>
                          <input v-model="form.cost" type="number" class="form-control" name="cost" />
                    </div>
                </div>
            </div>

            <!-- <div class="form-group row">
                <div class="col-md-4 offset-md-3">
                    <div class="form-check">
                        <label class="form-check-label">
                            <input v-model="form.tax" type="checkbox" name="tax" class="form-check-input" /> Add 13% HST
                        </label>
                    </div>
                </div>
            </div> -->

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Product links</label>

                <div class="col-md-8">
                     <div class="input-group"">
                        <input v-model="productLinkInput" @keydown.enter.prevent="addProductLink" @change="productInputChanged" placeholder="https://" type="text" class="form-control" name="product_link" />
                        <div class="input-group-append">
                            <button class="btn btn-light" :class="isProductLinkInputValidURL ? '' : 'disabled'" type="button" @click="addProductLink">Add</button>
                        </div>
                    </div>
                </div>

                <div v-if="productLinkFormatError" class="offset-md-3 col-md-8 mt-1">
                    <span class="text-danger">That doesn't quite look like a link 😬</span>
                </div>

                <div v-for="(productLink, index) in productLinks" :key="index" class="offset-md-3 col-md-8 mt-1">
                    <div class="productLink ellipsis">
                        <!-- HELLO -->
                        <div class="deleteButton" @click="deleteProductLink(productLink)">
                            <i class="fas fa-times"></i>
                        </div>
                        <a :href="productLink" target="_blank">{{ productLink }}</a>
                    </div>
                </div>

            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Image</label>
                <div class="col-md-8">
                    <input :ref="changeOrderImageRef" :id="changeOrderImagePickerId" type="file" accept="image/*" class="spark-uploader-control hide-input" name="changeOrderImage" @change="addImage" :disabled="form.busy" >
                    <button class="btn btn-light" @click="openImageFileDialog">{{ this.images.length > 0 ? "Add another image" : "Add an image" }}</button>
                </div>
                <div v-for="image in images" :key="image.id" class="offset-md-3 col-md-8">
                    <div class="row no-gutter">
                        <div class="col-md-12 image-file-group">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="image-file">{{ image.filename }} <span class="clickable ml-1 float-right" @click="cancelImage(image)"><i class="fa fa-times"></i></span></div>
                                </div>
                                <div class="col-md-6">
                                    <img id="localImagePreview" class="local-image-preview" :src="image.imageUrl" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Files</label>
                <div class="col-md-8">
                    <input :ref="changeOrderFileRef" :id="changeOrderFilePickerId" type="file" class="spark-uploader-control hide-input" name="changeOrderFile" @change="addFile" :disabled="form.busy" >
                    <button class="btn btn-light" @click="openFileDialog">{{ this.files.length > 0 ? "Add another file" : "Add a file" }}</button>
                </div>
                <div v-if="files.length > 0" class="offset-md-3 col-md-8">
                    <div class="row no-gutter">
                        <div class="col-md-12 image-file-group pb-0">
                            <div v-for="file in files" :key="file.id" class="row">
                                <div class="col-md-12">
                                    <div class="image-file mb-3">{{ file.filename }} <span class="clickable ml-1 float-right" @click="cancelFile(file)"><i class="fa fa-times"></i></span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="!isDraft" class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Notify team of approvals</label>
                <div class="col-md-2 my-auto">
                    <toggle-button :value="notifyTeam"
                                   @change="notifyTeamChanged"
                                   color="#000000"
                                   :sync="true"
                                   :width="75"
                                   :height="33"
                                   :labels="{checked: 'Yes', unchecked: 'No'}"
                                   :font-size="14"
                                   />
                </div>
            </div>

            <div v-if="!isDraft" class="form-group row">
                <label class="col-md-3 col-form-label text-md-right">Notify customer</label>
                <div class="col-md-2 my-auto">
                    <toggle-button :value="notifyCustomer"
                                   @change="notifyCustomerChanged"
                                   color="#000000"
                                   :sync="true"
                                   :width="75"
                                   :height="33"
                                   :labels="{checked: 'Yes', unchecked: 'No'}"
                                   :font-size="14"
                                   />
                </div>
            </div>

            <transition name="fade">
                <div key="key1" v-if="hasCustomers && !isDraft">
                    <div class="form-group row">
                        <div class="col-md-8 offset-md-3">
                            <div v-if="notifyCustomer" class="alert alert-light mb-0">
                                <p class="font-weight-600">
                                    <i class="fas fa-envelope"></i> <span class="ml-1">Good to know!</span>
                                </p>
                                <div v-if="isEditing">
                                    Site Command will send a notification to the following customers about the updates to this change order:
                                    <ul class="mt-2 mb-0">
                                        <li v-for="customer in project.customers">
                                            {{ customer.name }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>
                                    Creating this change order will send an approval request to the following customers:
                                    <ul class="mt-2 mb-0">
                                        <li v-for="customer in project.customers">
                                           {{ customer.name }}
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div v-else class="alert alert-light">
                                <p class="font-weight-600"><i class="fas fa-envelope"></i> <span class="ml-1">Heads up!</span></p>
                                <div v-if="isEditing">
                                    Notifications for this change order turned off. The customer will not receive notifications about this change order.
                                </div>
                                <div v-else>
                                    <span class="font-weight-600">The customer will not receive a notification for this change order</span>, but they will still need to approve it by logging into Site Command.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <div class="form-group row mb-0">
                <div class="col-md-8 offset-md-3">
                    <button type="button" class="btn btn-primary" @click="submit" :disabled="busy">{{saveButtonTitle}}</button>
                    <button v-if="changeorders && changeorders.length > 0" type="button" class="btn btn-secondary ml-2" @click="cancelForm">Cancel</button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    export default {
        props: ['role', 'project', 'changeorders', 'changeorder', 'isEditing', 'isDraft'],

        created: function() {

        },

        mounted: function() {

        },

        data: function() {
            return {
                form: new SparkForm({
                    title: this.changeorder && this.changeorder.title ? this.changeorder.title : '',
                    description: this.changeorder && this.changeorder.description ? this.changeorder.description : '',
                    cost: this.changeorder && this.changeorder.cost ? this.changeorder.cost : 0,
                    image: null,
                    product_link: this.changeorder && this.changeorder.product_link ? this.changeorder.product_link : '',
                    tax: 0,
                    project_id: null,
                    notifyCustomer: this.changeorder ? !!this.changeorder.notify_customer : true,
                    notifyTeam: this.changeorder ? !!this.changeorder.notify_team : true,
                }),
                error: false,
                errorMessage: '',
                //customer: null,

                images: this.getInitialImages(),
                imagesToDelete: [],

                files: this.getInitialFiles(),
                filesToDelete: [],

                productLinkInput: null,
                productLinks: this.changeorder ? this.changeorder.product_links : [],
                productLinkFormatError: false,

                notifyCustomer: this.changeorder ? !!this.changeorder.notify_customer : true,
                notifyTeam: this.changeorder ? !!this.changeorder.notify_team : true,
                busy: false
            };
        },

        computed: {

            isProductLinkInputValidURL: function() {

                if (!this.productLinkInput) return false;

                // Can't find a relaxed regex that will accept this actual URL:
                // https://www.berenson.ca/default.aspx?page=item+detail&itemcode=9905-1026-P&catlist=2331&parent=467#sthash.0zwc3Ohv.nXN120As.dpbs
                // or this one
                // https://www.flooranddecor.com/stone-decoratives/carrara-white-basket-weave-marble-mosaic-100139104.html#start=1

                return true;

                  // var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
                  //   '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
                  //   '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
                  //   '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
                  //   '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
                  //   '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
                //return !!pattern.test(this.productLinkInput);
            },

            hasCustomers: function() {
                return this.project.customers.length > 0;
            },

            changeOrderImageRef: function() {
                if (this.isDraft) {
                    return this.changeorder ? this.changeorder.id + '-draftChangeOrderImageRef' : 'draftChangeOrderImageRef';
                }
                return this.changeorder ? this.changeorder.id + '-changeOrderImageRef' : 'changeOrderImageRef';
            },

            changeOrderImagePickerId: function() {
                if (this.isDraft) {
                    return this.changeorder ? this.changeorder.id + '-draftChangeOrderImagePicker' : 'draftChangeOrderImagePicker';
                }
                return this.changeorder ? this.changeorder.id + '-changeOrderImagePicker' : 'changeOrderImagePicker';
            },

            changeOrderFileRef: function() {
                if (this.isDraft) {
                    return this.changeorder ? this.changeorder.id + '-draftChangeOrderFileRef' : 'draftChangeOrderFileRef';
                }
                return this.changeorder ? this.changeorder.id + '-changeOrderFileRef' : 'changeOrderFileRef';
            },

            changeOrderFilePickerId: function() {
                if (this.isDraft) {
                    return this.changeorder ? this.changeorder.id + '-draftChangeOrderFilePicker' : 'draftChangeOrderFilePicker';
                }
                return this.changeorder ? this.changeorder.id + '-changeOrderFilePicker' : 'changeOrderFilePicker';
            },

            saveButtonTitle: function() {
                if (this.isEditing) {
                    if (this.isDraft) {
                        return "Update draft change order";
                    }

                    if (this.hasCustomers && this.notifyCustomer) {
                        return "Update change order & notify customer";
                    }

                    return "Update change order";
                }

                if (this.isDraft) {
                    return "Create draft change order";
                }

                if (this.hasCustomers && this.notifyCustomer) {
                    return "Create change order & notify customer";
                }

                return "Create change order";
            }
        },

        watch: {
            notifyCustomer: function(newVal, oldVal) {
                this.form.notifyCustomer = newVal;
            },

            notifyTeam: function(newVal, oldVal) {
                this.form.notifyTeam = newVal;
            },
        },

        methods: {

            productInputChanged: function() {
                this.productLinkFormatError = false;
            },

            addProductLink: function() {
                if (this.isProductLinkInputValidURL) {
                    this.productLinkFormatError = false;

                    let tempUrl = this.productLinkInput;

                    //add protocol if necessary
                    var pattern = /^((http|https|ftp):\/\/)/;
                    if(!pattern.test(tempUrl)) {
                        tempUrl = "http://" + tempUrl;
                    }

                    this.productLinks.push(tempUrl);
                    this.productLinkInput = null;
                }
                else {
                    this.productLinkFormatError = true;
                }
            },

            deleteProductLink: function(productLinkToDelete) {
                let index = this.productLinks.indexOf(productLinkToDelete);
                this.productLinks.splice(index, 1);
            },

            getInitialImages: function() {
                let images = [];
                if (this.changeorder && this.changeorder.images.length > 0) {
                    _.forEach(this.changeorder.images, image => {
                        let imageData = {
                            id: image.id,
                            filename: image.filename,
                            imageUrl: image.url
                        };
                        images.push(imageData);
                    });
                    return images;
                }

                return images;
            },

            getInitialFiles: function() {
                let files = [];
                if (this.changeorder && this.changeorder.files.length > 0) {
                    _.forEach(this.changeorder.files, file => {
                        let fileData = {
                            id: file.id,
                            filename: file.filename,
                            fileUrl: file.url
                        };
                        files.push(fileData);
                    });
                    return files;
                }

                return files;
            },

            notifyCustomerChanged: function(event) {
                this.notifyCustomer = event.value;
            },

            notifyTeamChanged: function(event) {
                this.notifyTeam = event.value;
            },

            openImageFileDialog: function(e) {
                e.preventDefault();
                let imagePickerId = '#' + this.changeOrderImagePickerId;
                $(imagePickerId).click();
            },

            openFileDialog: function(e) {
                e.preventDefault();
                let filePickerId = '#' + this.changeOrderFilePickerId;
                $(filePickerId).click();
            },

            cancelImage: function(image) {
                this.imagesToDelete.push(image);
                this.images = _.reject(this.images, imageInArray => imageInArray.imageUrl === image.imageUrl);
            },

            cancelFile: function(file) {
                this.filesToDelete.push(file);
                this.files = _.reject(this.files, fileInArray => fileInArray.fileUrl === file.fileUrl);
            },

            resetForm: function() {
                this.form = new SparkForm({
                    title: '',
                    description: '',
                    cost: null,
                    image: null,
                    tax: 0,
                    project_id: null,
                    product_link: '',
                    notifyCustomer: true,
                    notifyTeam: true,
                });

                this.error = false;
                this.errorMessage = '';

                this.images = [];
                this.imagesToDelete = [];

                this.files = [];
                this.filesToDelete = [];
            },

            addImage: function(e) {
                e.preventDefault();

                let file = this.$refs[this.changeOrderImageRef].files[0];
                if (!file) return;
                let image = {
                    image: file,
                    filename: file.name,
                    imageUrl: URL.createObjectURL(file)
                };
                this.images.push(image);
            },

            addFile: function(e) {
                e.preventDefault();
                let fileRef = this.$refs[this.changeOrderFileRef].files[0];
                if (!fileRef) return;
                let file = {
                    file: fileRef,
                    filename: fileRef.name,
                    fileUrl: URL.createObjectURL(fileRef)
                };
                this.files.push(file);
            },

            cancelForm: function() {
                this.resetForm();
                if (this.isDraft) {
                    Bus.$emit('new-draft-change-order-canceled');
                }
                else {
                    Bus.$emit('new-change-order-canceled');
                }
            },

            newChangeOrderCreated: function(response) {
                this.resetForm();
                Bus.$emit('new-change-order-created', response);
                /*mixpanel.track('Change Order Created', {
                    title: response.title,
                });*/
            },

            changeOrderUpdated: function(response) {
                Bus.$emit('change-order-updated', response);
                /*mixpanel.track('Change Order Updated', {
                    title: response.title,
                });*/
            },

            newDraftChangeOrderCreated: function(response) {
                this.resetForm();
                Bus.$emit('new-draft-change-order-created', response);
                /*mixpanel.track('Draft Change Order Created', {
                    title: response.title,
                });*/
            },

            draftChangeOrderUpdated: function(response) {
                Bus.$emit('draft-change-order-updated', response);
                /*mixpanel.track('Draft Change Order Updated', {
                    title: response.title,
                });*/
            },

            submit: function(e) {

                this.error = false;
                this.busy = true;

                if (this.isEditing) {
                    axios.post(`/api/changeorders/${this.changeorder.id}/edit`, this.getFormData())
                        .then(response =>
                        {
                            if (this.isDraft) {
                                this.draftChangeOrderUpdated(response.data);
                            }
                            else {
                                this.changeOrderUpdated(response.data);
                            }
                            this.busy = false;
                        })
                        .catch(error =>
                        {
                            this.error = true;
                            this.busy = false;
                            if (error.response) {
                                if (error.response.data.error) {
                                    this.errorMessage = error.response.data.error;
                                }
                                else if (error.response.status == 500) {
                                    this.errorMessage = 'Sorry, we had some trouble creating that change order. Could you try again?';
                                }
                            }
                        });
                }
                else if (this.isDraft) {
                    axios.post('/api/changeorders/drafts', this.getFormData())
                        .then(response => {
                            this.newDraftChangeOrderCreated(response.data);
                            this.busy = false;
                        })
                        .catch(error => {
                            this.error = true;
                            this.busy = false;
                            if (error.response) {
                                if (error.response.data.error) {
                                    this.errorMessage = error.response.data.error;
                                }
                                else if (error.response.status == 500) {
                                    this.errorMessage = 'Sorry, we had some trouble creating that change order. Could you try again?';
                                }
                            }
                        });
                }
                else {
                    axios.post('/api/changeorders', this.getFormData())
                        .then(response => {
                            this.newChangeOrderCreated(response.data);
                            this.busy = false;
                        })
                        .catch(error => {
                            this.error = true;
                            this.busy = false;
                            if (error.response) {
                                if (error.response.data.error) {
                                    this.errorMessage = error.response.data.error;
                                }
                                else if (error.response.status == 500) {
                                    this.errorMessage = 'Sorry, we had some trouble creating that change order. Could you try again?';
                                }
                            }
                        });
                }
            },

            getFormData: function() {
                const data = new FormData();
                data.append('project_id', this.project.id);
                data.append('title', this.form.title);
                data.append('description', this.form.description);
                data.append('cost', this.form.cost);
                data.append('tax', this.form.tax);
                data.append('product_link', this.form.product_link);
                data.append('notify_customer', this.form.notifyCustomer);
                data.append('notify_team', this.form.notifyTeam);

                // If the user forgets to click "add" on a URL, we still want to
                // capture that user intent, so add the input if it's a valid URL.
                if (this.productLinkInput) {
                    if (this.productLinkInput.length > 0 && this.isProductLinkInputValidURL) {
                        data.append('product_links[]', this.productLinkInput);
                    }
                }

                _.forEach(this.productLinks, productLink => {
                    data.append('product_links[]', productLink);
                });

                _.forEach(this.images, image => {
                    if (image.image) {
                        data.append('images[][image]', image.image);
                        data.append('images[][filename]', image.filename);
                    }
                });

                _.forEach(this.imagesToDelete, image => {
                    if (image.id) {
                        data.append('images_to_delete[]', image.id);
                    }
                });

                _.forEach(this.files, file => {
                    if (file.file) {
                        data.append('files[][file]', file.file);
                        data.append('files[][filename]', file.filename);
                    }
                });

                _.forEach(this.filesToDelete, file => {
                    if (file.id) {
                        data.append('files_to_delete[]', file.id);
                    }
                });

                // There's a bug in the PUT method for PHP
                // Manually set the Put request to laravel
                // https://github.com/laravel/framework/issues/13457
                // https://bugs.php.net/bug.php?id=55815
                // if (this.isEditing) {
                //     data.append('_method', 'PUT');
                // }

                return data;
            },

            clickedProjectName: function() {
                $('a[href="#overview"]').trigger('click');
            }
        }
    }
</script>
